module.exports = __webpack_public_path__ + "html/political-landing_0073b87bbe991aff4c15fd34e90620fe.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing/political-landing.html
// module id = kvRk
// module chunks = 55